// extracted by mini-css-extract-plugin
export default {"checkboxSVG":"OnmpY","checkboxSvg":"OnmpY","checkbox-container":"_3nVm-","checkboxContainer":"_3nVm-"};